import React, { } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Button,
  Row,
  Col,
  Avatar,
  Tooltip
} from '@lockerpm/design';

import {
  BuildOutlined,
  ArrowRightOutlined
} from '@ant-design/icons'

const PageHeader = (props) => {
  const {
    isAvatar = false,
    avatarUrl,
    title = '',
    total = null,
    subtitle = '',
    actions = [],
    isEdit = false,
    isMarginTop = true,
    docOnboarding = '',
    docLink = '',
    docLabel = '',
    docClick = () => {},
    EditForm = () => <></>
  } = props

  const { t } = useTranslation()
  return (
    <>
      <Row
        gutter={[24, 8]}
        className={`
          admin-header
          flex
          items-center
          justify-between
        `}
        style={{
          height: 'auto'
        }}
      >
        <Col lg={actions.length > 0 ? 16 : 24} className="admin-header__left flex items-center">
          {
            isAvatar && avatarUrl && <Avatar
              className="mr-3"
              size={56}
              shape="square"
              src={avatarUrl}
            />
          }
          {
            isAvatar && !avatarUrl && <Avatar
              style={{ backgroundColor: '#1f2124' }}
              className="mr-3"
              size={56}
              shape="square"
              icon={<BuildOutlined />}
            />
          }
          <div className="w-full">
            {
              isEdit ? <EditForm /> : <h1
                className={`admin-header__left--title ${isMarginTop ? 'text-2xl' : 'text-xl'}`}
              >
                {title}
              </h1>
            }
            {
              ![null, undefined].includes(total) && <p
                className="admin-header__left--subtitle mt-1 text-black-200"
              >
                {t('common.total')}: {total}
              </p>
            }
          </div>
        </Col>
        <Col lg={actions.length > 0 ? 8 : 0} className="admin-header__right" align="right">
          <Row gutter={[8, 8]} justify="end">
            {
              actions.filter((a) => !a.hide).map((a) =>
                <Col key={a.key}>
                  <Tooltip
                    title={a.tooltipTitle}
                    placement="bottom"
                  >
                    <Button
                      size={a.size}
                      key={a.key}
                      type={a.type}
                      loading={a.loading}
                      danger={a.danger}
                      disabled={a.disabled}
                      onClick={() => a.click()}
                      icon={a.icon}
                    >
                      {a.label}
                    </Button>
                  </Tooltip>
                </Col>
              )}
          </Row>
        </Col>
      </Row>
      {
        subtitle && <p className="admin-header__left--subtitle mt-1 lg:w-2/3">
          {subtitle}
        </p>
      }
      {
        docLabel && <span
          className="admin-header__left--doc mt-1 flex items-center w-max cursor-pointer text-info"
          onClick={() => docLink ? window.open(docLink, '_blank') : docClick()}
        >
          <Tooltip
            title={docOnboarding}
            placement={'bottomLeft'}
          >
            <span className="mr-2">{docLabel}</span>
          </Tooltip>
          <ArrowRightOutlined />
        </span>
      }
    </>
  );
}

export default PageHeader;